@if (showColorCfg) {
  <color-cfg [colorKey]="data.colorKey"></color-cfg>
}
@if (mayDebug) {
  <button (click)="globals.isDebug = !globals.isDebug" [class]="classForDebug" mat-icon-button micro-button>
    @if (!globals.isDebug) {
      <mat-icon>bug_report</mat-icon>
    }
    @if (globals.isDebug) {
      <mat-icon>pest_control</mat-icon>
    }
  </button>
}
@if (data.showClose ?? true) {
  <button (click)="clickClose()" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
}
